import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';

interface BtnStyleProps {
    active: boolean;
}

export const ButtonMoveType = styled.button<BtnStyleProps>`
    display: flex;
    height: 84px;
    background-color: ${palette('surface_base')};
    cursor: pointer;
    border: solid ${(props) => (props.active ? css`2px ${palette('text_primary')}` : css`1px rgba(0, 0, 0, 0.12)`)};
    outline: 0;
    width: 100%;
`;

export const MoveType = styled.label<BtnStyleProps>`
    cursor: pointer;
    width: 120px;
    float: left;
    padding: 10px 0;
    color: ${palette('text_dark_main')};
    ${theme('fontStyle.body1')}
    ${(props) =>
        props.active
            ? css`
                  font-weight: bold;
              `
            : null}
`;

export const MoveTypeDescription = styled.label<BtnStyleProps>`
    cursor: pointer;
    text-align: left;
    color: ${palette('text_dark_main')};
    ${theme('fontStyle.body2')}
`;
